const global = window

const inputs = {
    registered: {},
    contextual: {},
    types: {},
    fn: {},
    alias: {},
    behavior: {},
}
global.inputs = inputs;

global.registerInput = function registerInput(name, type, dataOpt) {
    let data = dataOpt
    const realName = data && data.name ? data.name : null
    // console.log('INPUT : ' + type + ' ' + name);
    let input;
    if (typeof name === 'string') input = $('#' + name)
    else input = $(name);
    if (!input.length) return false
    const parent = input.parent()
    input.data('data', data)
    const inputWindow = input.closest('[data-api], .window, body')
    const niceName = data.id != name && data.id ? data.id : data.name
    data.html = input
    type = type.charAt(0).toLowerCase() + type.slice(1)

    if (input.data('registered') === true) return false;

    // precopy data
    input.data('data', data);

    /*
    if (realName && (inputs.contextual[realName] || inputs.contextual[realName] === 0)) {
        data.value = inputs.contextual[realName];
        console.log(realName + ' - ' + inputs.contextual[realName]);
    }
    */

    // inputWindow identifier
    if (!inputWindow.data('behavkey')) {
        if (inputWindow.is('body')) {
            inputWindow.data('behavkey', 'root')
        }
        else {
            inputWindow.data('behavkey', ((inputWindow.attr('id')) ? formatFilename(inputWindow.attr('id'))+'_' : '') + generateRandomString(20))
        }
        // console.log('REG '+inputWindow.data('behavkey'));
    }

    // types
    let typeRef = data.type
    if (!inputs.alias[typeRef] && !inputs.types[typeRef]) typeRef = type
    if (inputs.alias[typeRef]) typeRef = inputs.alias[typeRef]
    if (inputs.types[typeRef]) {
        const typeFn = inputs.types[typeRef];
        data = typeFn(data, name, niceName, type, input, parent, inputWindow);
    }

    // behaviors
    const behaviorKeys = Object.keys(inputs.behavior);
    behaviorKeys.forEach((key) => {
        const behaviorFn = inputs.behavior[key];
        data = behaviorFn(data, name, niceName, type, input, parent, inputWindow);
    });

    inputs.registered[name] = data

    // event change
    if (data.onChange) {
        input.change(function (event) {
            eval(data.onChange);
        })
    }

    // redundancy
    if (data.redundancy) {
        input.data('redundancy', data.redundancy)
    }

    // min
    if (data.min) {
        input.data('min', data.min)
    }

    // max
    if (data.max) {
        input.data('max', data.max)
    }

    // test
    if (data.test) {
        input.data('test', data.test)
        input.change(function () {
            $(this).removeClass('tested')
            $(this).removeClass('tested--success')
            $(this).removeClass('tested--error')
        })
    }

    // Backup original data
    data.valueLast = getFieldData(data.name, parent)

    // data
    input.data('data', data);
    // console.log(niceName, data);
    if (data.data) {
        $.each(data.data, function(key, value) {
            input.data(key, value);
        });
    }

    // registration
    input.data('registered', true)
}

global.inputReloadParent = function (input) {
    $(input).closest('.grid').find('.ajaxable').data('data')
        .reload()
}
